import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateDepartmentRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { deleteDepartment } from '../../api/departments.api';

/**
 * Hook to delete a department.
 * Handles mutation, cache invalidation for departments and related team member queries.
 *
 * @returns TanStack Query mutation for deleting a department
 */
export const useDeleteDepartment = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: deleteDepartment,
    onSuccess: async () => {
      // Invalidate department and team member queries
      await invalidateDepartmentRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
